import React, { useEffect, useMemo, useState } from 'react'
import MasterService from '../../../services/master/MasterService'
import TransaksiService from '../../../services/transaksi/TransaksiService'
import { Button, Modal, OverlayTrigger, Tooltip } from 'react-bootstrap'
import { AsyncPaginate } from 'react-select-async-paginate'
import Disposisi from '../../../utilities/Disposisi'
import GetDokumen from '../../../utilities/GetDokumen'
import { FaEye } from 'react-icons/fa'

const ModalViewLapVerLap = ({ showViewLapVerLap, handleCloseViewLapVerLap, dataDisposisi, datappm }) => {

    const [listKomponenVerlap, setListKomponenVerlap] = useState([])
    const [stsRadioValues, setStsRadioValues] = useState({})
    const [checkCesium, setCheckCesium] = useState('0')
    const [valueKeterangan, setValueKeterangan] = useState(null)

    let masterService = useMemo(() => new MasterService(), [])
    let transaksiService = useMemo(() => new TransaksiService(), [])

    useEffect(() => {
        const getListKomponenVerlap = async () => {
            try {
                const response = await masterService.listKomponenVerlap(0, 20)
                setListKomponenVerlap(response.data.data)
            } catch (error) {
                console.log(error)
            }
        }
        getListKomponenVerlap()
    }, [masterService])

    useEffect(() => {
        if (!dataDisposisi) return
        const getSpp = async () => {
            try {

                // const resHasilEv = await transaksiService.listHasilVerLapangan(0, datappm.nomorAju, 0, 1)
                const resHasilEv = await transaksiService.getHasilVerLapanganByAjuNoTugas(datappm.nomorAju, dataDisposisi.noTugas)

                let hasilEvPermohonan = resHasilEv.data
                setStsRadioValues({ '1006': hasilEvPermohonan.stsProduk, '1005': hasilEvPermohonan.stsSpecies, '1018': hasilEvPermohonan.stsJnsOlah, '1019': hasilEvPermohonan.stsKemas })
                setCheckCesium(hasilEvPermohonan.stsPrint)

                let kesimpulan = { idKesimpulan: hasilEvPermohonan.idKesimpulan, kesimpulan: hasilEvPermohonan.kseimpulan }
                setValueKesimpulanOpt(kesimpulan)
                setValueKeterangan(hasilEvPermohonan.keterangan)
            } catch (error) {
                console.log(error)
                // setListPenugasanDetil([])
                // setHasilEv(null)
            }
        }
        getSpp()
    }, [transaksiService, dataDisposisi, datappm])

    const [valueKesimpulanOpt, setValueKesimpulanOpt] = useState(null)

    async function loadOptionKesimpulan(search, loadedOption, { page = 1 }) {
        const response = await masterService.listKesimpulan('lhd', search, page - 1, 20)
        return {
            options: response.data.data,
            hasMore: response.data.data.length >= 10,
            additional: {
                page: page + 1
            }
        }
    }

    const onChangeKesimpulan = e => {
        setValueKesimpulanOpt(e)
    }

    const [showOpenPreview, setShowOpenPreview] = useState(false)
    const handleClosePreview = () => {
        setBase64String(null)
        setShowOpenPreview(false)
    }

    const [base64String, setBase64String] = useState(null)

    const handleClickPreviewDok = async (idJnsDok, nomorAju) => {
        try {
            const resDok = await transaksiService.getPpmDokByAjuKodeDok(nomorAju, idJnsDok)
            if (resDok.data !== '') {
                setBase64String(resDok.data.dokPath)
                setShowOpenPreview(true)
            }
        } catch (error) {
            console.log(error)
        }
    }

    return (
        <>
            <Modal show={showViewLapVerLap}
                onHide={handleCloseViewLapVerLap}
                backdrop='static'
                keyboard={false}
                size="xl"
                centered
            >
                <Modal.Header>
                    <h6><Disposisi idDisposisi={dataDisposisi.idDisposisi} /></h6>
                </Modal.Header>
                <Modal.Body>
                    <div className="row mb-3">
                        <label className="col-sm-2 col-form-label-sm">Nomor Aju</label>
                        <div className="col-sm-6">
                            <input type="text" className="col-sm-12 form-control-sm" name="nomor_aju" defaultValue={datappm.nomorAju} readOnly />
                        </div>
                    </div>
                    <div className='row mb-3'>
                        {
                            listKomponenVerlap.map((komp, index) => {
                                return (
                                    <>
                                        <div key={index} className='row mb-3'>
                                            <label className='col-sm-1 col-form-label-sm'>{index + 1}</label>
                                            <div className="col-sm-4">
                                                <input type="text" className="col-sm-12 form-control-sm" name="komponen" defaultValue={komp.komponen} readOnly />
                                            </div>
                                            <div className="col-sm-2">
                                                {/* <input type="text" className="col-sm-12 form-control-sm" name="dokwajib" defaultValue={GetNomorDok(dokwajib.idJnsDok)} readOnly /> */}
                                                <GetDokumen nomorAju={datappm.nomorAju} idJnsDok={komp.tipe} />
                                            </div>
                                            <div className='col-sm-3'>
                                                {/* <div class="form-check form-switch">
                                                    <input class="form-check-input" type="checkbox" id={"flexSwitchCheckChecked" + index} />
                                                    <label class="form-check-label" for={"flexSwitchCheckChecked" + index}>Sesuai</label>
                                                </div> */}
                                                <div className="col-sm-12">
                                                    <div class="form-check form-check-inline">
                                                        <input class="form-check-input" type="radio" name={'inlineRadio' + komp.field} id={'inlineRadio' + komp.field} value="1" checked={stsRadioValues[komp.tipe] === '1'} readOnly />
                                                        <label class="form-check-label" for={'inlineRadio' + komp.field}>Sesuai</label>
                                                    </div>
                                                    <div class="form-check form-check-inline">
                                                        <input class="form-check-input" type="radio" name={'inlineRadio' + komp.field} id={'inlineRadio' + komp.field} value="0" checked={stsRadioValues[komp.tipe] === '0'} readOnly />
                                                        <label class="form-check-label" for={'inlineRadio' + komp.field}>Tidak Sesuai</label>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className='col-sm-2'>
                                                <OverlayTrigger placement="bottom" overlay={
                                                    <Tooltip >Preview Dokumen</Tooltip>
                                                }>
                                                    <Button size="sm" variant="outline-info" onClick={() => handleClickPreviewDok(komp.tipe, datappm.nomorAju)}>
                                                        <FaEye /> Preview
                                                    </Button>
                                                </OverlayTrigger>{' '}
                                            </div>
                                        </div>
                                    </>
                                )
                            })
                        }
                    </div>
                    <div className="row mb-3">
                        <label className="col-sm-2 col-form-label-sm">Bebas Cessium-137</label>
                        <div className="col-sm-8">
                            <div class="form-check form-check-inline">
                                <input class="form-check-input" type="checkbox" name={'checkCesium'} id={'checkCesium'} value="1" checked={checkCesium === '1' ? true : false} readOnly />
                                <label class="form-check-label" for={'checkCesium'}><span className='text-danger'>Khusus Negara Tujuan Amerika, Komoditi Udang dan Area Jawa Lampung</span></label>
                            </div>
                        </div>
                    </div>
                    <div className='row mb-3'>
                        <label className="col-sm-2 col-form-label-sm">Kesimpulan</label>
                        <div className='col-sm-8'>
                            <AsyncPaginate
                                loadOptions={loadOptionKesimpulan}
                                value={valueKesimpulanOpt}
                                getOptionLabel={(option) => option.kesimpulan}
                                getOptionValue={(option) => option.idKesimpulan}
                                additional={{
                                    page: 1
                                }}
                                onChange={onChangeKesimpulan}
                                isDisabled={true}
                            />
                        </div>
                    </div>
                    <div className="row mb-3">
                        <label className="col-sm-2 col-form-label-sm">Alasan Penolakan</label>
                        <div className="col-sm-6">
                             <textarea cols={6} rows={5} className="col-sm-12 form-control-sm" name="keterangan" value={valueKeterangan} disabled />
                        </div>
                    </div>
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="danger" size="sm" onClick={handleCloseViewLapVerLap}>Kembali</Button>
                </Modal.Footer>
            </Modal>
            <PreviewPdf showOpenPreview={showOpenPreview} handleClosePreview={handleClosePreview} base64string={base64String} />
        </>
    )
}

const PreviewPdf = ({ showOpenPreview, handleClosePreview, base64string }) => {
    // const pdfUrl = 'data:application/pdf;base64,' + base64string

    return (
        <>
            <Modal show={showOpenPreview} onHide={handleClosePreview} size='xl'>
                <iframe
                    src={base64string}
                    title='Preview PDF'
                    width="100%"
                    height="800px"
                ></iframe>
            </Modal>
        </>
    )
}

export default ModalViewLapVerLap